const KEY = "checkout_session";

export const getSession = () => {
  const data = sessionStorage.getItem(KEY);
  console.log(data);
  return data ? JSON.parse(data) : null;
};

export const setSession = (session) => {
  sessionStorage.setItem(KEY, JSON.stringify(session));
};

export const clearSession = () => {
  sessionStorage.removeItem(KEY);
};
